"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openLocation = openLocation;
Object.defineProperty(exports, "RemoteFileWithRangeCache", {
  enumerable: true,
  get: function get() {
    return _RemoteFileWithRangeCache.RemoteFileWithRangeCache;
  }
});

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _genericFilehandle = require("generic-filehandle");

var _RemoteFileWithRangeCache = require("./RemoteFileWithRangeCache");

var _types = require("../types");

var _tracks = require("../tracks");

var _detectNode = _interopRequireDefault(require("detect-node"));

function isLocalPathLocation(location) {
  return 'localPath' in location;
}

function isBlobLocation(location) {
  return 'blobId' in location;
}

function openLocation(location, pluginManager) {
  function checkAuthNeededFetch(_x, _x2) {
    return _checkAuthNeededFetch.apply(this, arguments);
  }

  function _checkAuthNeededFetch() {
    _checkAuthNeededFetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, opts) {
      var response, authHeaders;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(url, opts);

            case 2:
              response = _context.sent;

              if (!(response.status === 401)) {
                _context.next = 7;
                break;
              }

              authHeaders = response.headers.get('WWW-Authenticate');

              if (!((0, _types.isUriLocation)(location) && authHeaders && authHeaders.includes('Basic'))) {
                _context.next = 7;
                break;
              }

              throw new _types.AuthNeededError('Accessing HTTPBasic resource without authentication', location);

            case 7:
              return _context.abrupt("return", response);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _checkAuthNeededFetch.apply(this, arguments);
  }

  if (!location) {
    throw new Error('must provide a location to openLocation');
  }

  if (isLocalPathLocation(location)) {
    if (!location.localPath) {
      throw new Error('No local path provided');
    }

    if (_detectNode.default) {
      return new _genericFilehandle.LocalFile(location.localPath);
    } else {
      throw new Error("can't use local files in the browser");
    }
  }

  if (isBlobLocation(location)) {
    // special case where blob is not directly stored on the model, use a getter
    var blob = (0, _tracks.getBlob)(location.blobId);

    if (!blob) {
      throw new Error("file (\"".concat(location.name, "\") was opened locally from a previous session. To restore it, go to track settings and reopen the file"));
    }

    return new _genericFilehandle.BlobFile(blob);
  }

  if ((0, _types.isUriLocation)(location)) {
    if (!location.uri) {
      throw new Error('No URI provided');
    }

    if (location.internetAccountPreAuthorization) {
      if (!pluginManager) {
        throw new Error('need plugin manager to open locations with an internet account');
      }

      var rootModel = pluginManager.rootModel;

      if (rootModel && !(0, _types.isAppRootModel)(rootModel)) {
        throw new Error('This context does not support internet accounts');
      }

      var internetAccount;

      if (rootModel) {
        internetAccount = rootModel.findAppropriateInternetAccount(location);
      } else {
        var internetAccountType = pluginManager.getInternetAccountType(location.internetAccountPreAuthorization.internetAccountType);
        internetAccount = internetAccountType.stateModel.create({
          type: location.internetAccountPreAuthorization.internetAccountType,
          configuration: location.internetAccountPreAuthorization.authInfo.configuration
        });

        if (!location.internetAccountPreAuthorization.authInfo.token) {
          throw new Error('Failed to obtain token from internet account. Try reloading the page');
        }
      }

      if (!internetAccount) {
        throw new Error('Could not find associated internet account');
      }

      return internetAccount.openLocation(location);
    } else if (location.internetAccountId) {
      if (!pluginManager) {
        throw new Error('need plugin manager to open locations with an internet account');
      }

      var _rootModel = pluginManager.rootModel;

      if (_rootModel && !(0, _types.isAppRootModel)(_rootModel)) {
        throw new Error('This context does not support internet accounts');
      }

      if (_rootModel) {
        var modifiedLocation = JSON.parse(JSON.stringify(location));

        var _internetAccount = _rootModel.findAppropriateInternetAccount(location);

        if (!_internetAccount) {
          throw new Error('Could not find associated internet account');
        }

        _internetAccount.getPreAuthorizationInformation(location).then( // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (preAuthInfo) {
          return modifiedLocation.internetAccountPreAuthorization = preAuthInfo;
        });

        return _internetAccount.openLocation(modifiedLocation);
      }

      throw new Error('Could not pre-authorize location');
    }

    var url = location.baseUri ? new URL(location.uri, location.baseUri).href : location.uri;
    return new _RemoteFileWithRangeCache.RemoteFileWithRangeCache(url, {
      fetch: checkAuthNeededFetch
    });
  }

  throw new Error('invalid fileLocation');
}